import { Entidad } from "../Entidad";

export enum CFinanzaPagoEnLineaEstado {
    Pendiente = 1,
    Pagado = 2,
}

export enum CFinanzaPagoEnLineaFormaPago {
    Tarjeta = 1,
    TransferenciaBancaria = 2,
    Efectivo = 3
}

export interface IFinanzaFolioPagoEnLinea {
    EstadoPago: CFinanzaPagoEnLineaEstado;
    FechaVigencia: string | null;
    FechaCreacion: string;
    /** @example "OVEJA25-000001" */
    Folio: string;
    FormaPago: CFinanzaPagoEnLineaFormaPago;
    Id: number;
    IdsMovimientos: number[];
    Montos: number[];
    TiposPago: Entidad.CTipoPago[];
    /**
     * >0: Id Tutor
     * <0: ??
     */
    IdUsuarioCreo: number;
    RequiereFactura: boolean;
    /** Si no requiere factura es `null` */
    IdFacturaFolio: number | null;
}
